/* Overview — hôm nay con cần làm gì: buổi học tiếp theo + thông tin lớp. */
import { Link } from "react-router-dom"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Icon } from "@/components/icon"
import { Page, PageHeader, usePageTitle } from "@/components/page"
import { useClass } from "@/app/ClassLayout"
import { formatDisplayDate, pickNextSession, sessionDisplayTitle } from "@/lib/format"
import { ClassMeta, QuietDetails } from "./start-awards/shared"

export default function OverviewPage() {
  const { base, data } = useClass()
  const course = data.class || {}
  const { next } = pickNextSession(data.sessions || [])
  usePageTitle(`Tổng quan · ${course.course_name || "Lớp học"}`, "Buổi học tiếp theo và thông tin lớp.")

  return (
    <Page>
      <PageHeader eyebrow="Hôm nay" title="Con cần làm gì?" />
      <Card className="bg-paper">
        <CardContent className="flex flex-col gap-4">
          <Badge variant="success" className="w-fit">
            <Icon name="check-circle" className="size-4" /> Lớp đã sẵn sàng
          </Badge>
          <div className="flex flex-col gap-1">
            {next && <p className="text-sm font-semibold text-orange-strong">Buổi {next.session_number}</p>}
            <h2 className="font-heading text-2xl font-bold text-ink">{(next && (sessionDisplayTitle(next) || next.title)) || course.course_name}</h2>
            <p className="flex flex-wrap items-center gap-2 text-base text-muted-foreground">
              {next ? (
                <>
                  <Icon name="calendar" className="size-4" /> {formatDisplayDate(next.session_date)}
                  <Icon name="clock" className="size-4" /> {next.starts_at || "Chưa có giờ"}
                </>
              ) : (
                "Mentor sẽ cập nhật buổi học tiếp theo."
              )}
            </p>
          </div>
          <Button nativeButton={false} className="w-full sm:w-fit" render={<Link to={`${base}/sessions`} />}>
            {course.meeting_url ? "Xem lịch và vào Zoom" : "Xem lịch"} <Icon name="arrow-right" />
          </Button>
        </CardContent>
      </Card>
      <QuietDetails summary="Thông tin lớp">
        <ClassMeta course={course} />
      </QuietDetails>
    </Page>
  )
}
